import { cn as m } from "../../../lib/shadcn/utils/utils.js";
import { Spinner as a } from "../../../lib/shadcn/ui/components/spinner.js";
import { jsx as n } from "react/jsx-runtime";
var p = {
  sm: "size-3",
  md: "size-4",
  lg: "size-6",
  xl: "size-8",
  xxl: "size-25"
}, t = ({ size: e = "md", className: s, dataTestid: i, ...r }) => /* @__PURE__ */ n(a, {
  className: m(p[e], s),
  "data-testid": i,
  ...r
});
t.displayName = "Spinner";
export {
  t as Spinner
};

//# sourceMappingURL=Spinner.js.map